import { Orientation } from '../../../feature/export/Utils.js';
import Combo from '../../../../Core/widget/Combo.js';

export default class ExportOrientationCombo extends Combo {

    //region Config

    static $name = 'ExportOrientationCombo';

    // Factoryable type name
    static type = 'exportorientationcombo';

    static configurable = {
        editable : false,

        localizeDisplayFields : true
    };

    //endregion

    buildItems() {
        return [
            { id : Orientation.portrait, text : 'L{portrait}' },
            { id : Orientation.landscape, text : 'L{landscape}' }
        ];
    }
}

// Register this widget type with its Factory
ExportOrientationCombo.initClass();
